<template>
  <div class="policyArea">
    <h1>{{ t('common-privacy-policy') }}</h1>
    <p v-if="policy?.date" class="date">{{ policy.date }}</p>
    <header
      v-if="policy?.headerHtml"
      class="markdownBody policyHeaderArea"
      v-html="policy.headerHtml"
    />
    <div
      v-for="(intro, idx) in policy?.introSections ?? []"
      :key="`intro-${idx}`"
      class="policyItem markdownBody"
      v-html="intro"
    />
    <div
      v-for="(article, idx) in policy?.articles ?? []"
      :id="`Article${idx + 1}`"
      :key="`article-${idx}`"
      class="policyItem"
    >
      <div class="policyInfo" :class="{ on: openFlags[idx] }">
        <div class="titleArea" @click.stop="toggle(idx)">
          <h2>{{ article.title }}</h2>
          <div class="toggleBtn" />
        </div>
        <div class="infoArea markdownBody" v-html="article.html" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const { policy } = usePolicyMarkdown('privacy');
const openFlags = ref<boolean[]>([]);

watchEffect(() => {
  openFlags.value = (policy.value?.articles ?? []).map(() => true);
});

const toggle = (idx: number) => {
  openFlags.value[idx] = !openFlags.value[idx];
};
</script>
